import { Utils } from '../../Core';
import { CommonContentApi as API } from '../../Apis';
import { mocksService } from './CommonContent.mock';
import { CommonContentTypes } from '../../Types';
import { CommonContentInternalsTypes } from '../../Types/internals';

const prepareCall = (data: CommonContentTypes.CommonContentParamsPrepare) => {
  return API.call.get({ searchId: data.params });
};

const handleSucessFinalResponseFunction = (
  data: CommonContentInternalsTypes.CommonContentRawResponse,
): CommonContentTypes.CommonContentData => {
  return { htmlContent: data.htmlContent };
};

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction: prepareCall,
  handleResponse: {
    handleSucessFinalResponseFunction,
  },
  definitionsAPI: API.definitions,
  mocksService,
});
